import dayjs from "dayjs";

export const getVkSession = () => sessionStorage.getItem(process.env.REACT_APP_VK_PARAM_NAME);

export const getIsVkSession = () => {
    const session = getVkSession();
    return (session != null && session !== "");
}

/** Получить строку адреса в формате http://domain:port */
export const getFullAddress = () => {
  // Получаем протокол (http: или https:)
  const protocol = window.location.protocol;
  
  // Получаем домен (включая поддомен, если есть)
  const hostname = window.location.hostname;
  
  // Получаем порт
  const port = window.location.port;
  
  // Определяем, является ли порт стандартным для протокола
  const isStandardPort = 
    (protocol === 'http:' && port === '80') || 
    (protocol === 'https:' && port === '443');
  
  // Формируем строку адреса
  let fullAddress = protocol + '//' + hostname;
//  let fullAddress = hostname;
  
  // Добавляем порт, только если он нестандартный
  if (port && !isStandardPort) {
    fullAddress += ':' + port;
  }
  
  return fullAddress;
}

export const fmtDateTimeFull = (value) => {
  return value && dayjs(value).format("DD.MM.YYYY HH:mm:ss");
}

// export const generateUuidNoDashes = () => {
//   // Формат UUID: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
//   const rnds = new Uint8Array(16);
//   window.crypto.getRandomValues(rnds);

//   // Вставляем версии и варианты согласно UUIDv4
//   rnds[6] = (rnds[6] & 0x0f) | 0x40;
//   rnds[8] = (rnds[8] & 0x3f) | 0x80;

//   const hex = Array.from(rnds, b => b.toString(16).padStart(2, '0')).join('');
//   // hex уже без дефисов, это и есть UUID без дефисов
//   return hex;
// }